"use client";
import CardsList from "@/components/cardsList";
import { SOLUTIONS_CONSTANTS } from "./constants";

const SolutionComponent = () => {
  return (
    <CardsList
      columns={{ base: 1, md: 2 }}
      list={SOLUTIONS_CONSTANTS.list}
      spacing={{ base: 8, md: 20 }}
      title={SOLUTIONS_CONSTANTS.title}
    />
  );
};

export default SolutionComponent;
